/**
 * MouseState enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file MouseState.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum MouseState {
  NONE = 0,
  LEFT = 1,
  MIDDLE = 2,
  RIGHT = 3,
  None
}